<div class="venue-map">
  <div class="toolbar">
    <p-autoComplete [(ngModel)]="suburbQuery" [suggestions]="suburbHits" (completeMethod)="findSuburbs($event)" (onSelect)="pickSuburb($event)" field="name"
      [minLength]="2" [delay]="200" appendTo="body" [baseZIndex]="12000" placeholder="Suburb" styleClass="suburb-search" inputStyleClass="w-full">
      <ng-template let-s pTemplate="item">{{ s.name }} <span class="text-500">{{ s.state }}</span></ng-template>
    </p-autoComplete>
    <input #googleInput [hidden]="!googleAvailable" type="text" class="p-inputtext p-component google-search" placeholder="Or search Google for a place" />
    <p-dropdown [options]="purposes" [ngModel]="purpose" (ngModelChange)="setPurpose($event)" optionLabel="label" optionValue="value" appendTo="body" [baseZIndex]="12000" styleClass="purpose"></p-dropdown>
    <p-selectButton [options]="radii" [ngModel]="radiusKm" (ngModelChange)="setRadius($event)" optionLabel="label" optionValue="value" styleClass="radius"></p-selectButton>
    <button pButton type="button" class="p-button-outlined p-button-sm" [label]="more ? 'Hide other places' : 'View more places'" (click)="toggleMore()"></button>
  </div>
  <div *ngIf="more" class="groups">
    <button *ngFor="let g of groupOptions" type="button" class="chip" [class.on]="groups.includes(g.value)" (click)="toggleGroup(g.value)">{{ g.label }}</button>
  </div>

  <div class="body">
    <div class="list">
      <div class="status text-sm">
        <span>Near <strong>{{ centre.label }}</strong>, within {{ radiusKm }} km.</span>
        <span *ngIf="result && (result.providers.length || result.unplaced.length)" class="text-600">
          Ranked by {{ result.rankedBy === '12m' ? 'use in the last 12 months' : 'use over all time, then how recently (not much use here in 12 months)' }}.
        </span>
        <span *ngIf="loading" class="text-600"><i class="pi pi-spin pi-spinner"></i> Loading…</span>
      </div>
      <div *ngIf="error" class="error text-sm">{{ error }}</div>

      <ng-container *ngIf="result">
        <h4>Places we've used</h4>
        <div *ngIf="!result.providers.length" class="empty text-sm">None on the map near here{{ result.unplaced.length ? ' yet' : '' }}.</div>
        <ng-container *ngFor="let c of cards; trackBy: cardKey">
          <div *ngIf="c.kind === 'provider'" [id]="'venue-card-' + c.key" class="card provider" [class.on]="selected === c.key" (click)="select(c.key)">
            <span class="rank">{{ c.rank }}</span>
            <div class="min-w-0">
              <div class="font-medium">{{ c.item.name }}</div>
              <div class="text-sm text-600">{{ typeLabel[c.item.blockType] }} · {{ distanceText(c.item.distanceM) }}<span *ngIf="c.item.positionSource === 'pin'"> · pinned by hand</span></div>
              <div class="text-sm">{{ usageText(c.item.usage) }}</div>
              <div *ngIf="c.item.phone" class="text-sm"><a [href]="'tel:' + c.item.phone" (click)="$event.stopPropagation()">{{ c.item.phone }}</a></div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="result.unplaced.length">
          <h4>Used before, not on the map yet</h4>
          <div class="text-sm text-600 mb-2">These providers' places are waiting for a check on Service Providers → Locations. Distances are from their suburb.</div>
          <div *ngFor="let u of result.unplaced; trackBy: unplacedKey" class="card unplaced">
            <span class="rank muted"><i class="pi pi-map-marker"></i></span>
            <div class="min-w-0">
              <div class="font-medium">{{ u.name }}</div>
              <div class="text-sm text-600">{{ typeLabel[u.blockType] }} · {{ addressText(u) }} · about {{ distanceText(u.suburbDistanceM) }}</div>
              <div class="text-sm">{{ usageText(u.usage) }}</div>
              <div *ngIf="u.phone" class="text-sm"><a [href]="'tel:' + u.phone">{{ u.phone }}</a></div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="result.handTyped.length">
          <h4>Typed in by hand before</h4>
          <ng-container *ngFor="let c of cards; trackBy: cardKey">
            <div *ngIf="c.kind === 'hand'" [id]="'venue-card-' + c.key" class="card hand" [class.on]="selected === c.key" (click)="select(c.key)">
              <span class="rank hand">H</span>
              <div class="min-w-0">
                <div class="font-medium">{{ c.item.name || '(unnamed)' }}</div>
                <div class="text-sm text-600">{{ kindLabel(c.item.kind) }} · {{ distanceText(c.item.distanceM) }}</div>
                <div class="text-sm">Used by hand {{ c.item.countAll }}×<span *ngIf="c.item.lastUsedAt">, last {{ dateText(c.item.lastUsedAt) }}</span> (not a provider)</div>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="more">
          <h4>Other places</h4>
          <div *ngIf="!result.datasetLive" class="empty text-sm crawl-missing">Crawl data isn't loaded here, so there are no other places to show.</div>
          <ng-container *ngIf="result.datasetLive">
            <div *ngIf="!groups.length" class="empty text-sm">Pick a kind of place above.</div>
            <div *ngIf="groups.length && !result.places.length" class="empty text-sm">No places of those kinds within {{ radiusKm }} km.</div>
            <div *ngIf="result.placesCapped" class="note text-sm">The nearest {{ result.places.length }} of {{ result.placesTotal }}: pick fewer kinds or a smaller distance.</div>
            <ng-container *ngFor="let c of cards; trackBy: cardKey">
              <div *ngIf="c.kind === 'place'" [id]="'venue-card-' + c.key" class="card place" [class.on]="selected === c.key" (click)="select(c.key)">
                <span class="rank place"></span>
                <div class="min-w-0">
                  <div class="font-medium">{{ c.item.name || '(unnamed)' }} <span *ngIf="c.item.curation === 'candidate'" class="candidate">Candidate</span></div>
                  <div class="text-sm text-600">{{ kindLabel(c.item.kind) }} · {{ distanceText(c.item.distanceM) }}</div>
                  <div class="text-sm links">
                    <a *ngIf="c.item.website" [href]="c.item.website" target="_blank" rel="noopener noreferrer nofollow" (click)="$event.stopPropagation()">Website</a>
                    <a *ngIf="c.item.phone" [href]="'tel:' + c.item.phone" (click)="$event.stopPropagation()">{{ c.item.phone }}</a>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <div class="footer text-xs text-500">
          Usage counted {{ dateText(result.usageComputedAt) }}<ng-container *ngIf="result.datasetLive">; places from the crawl of {{ dateText(result.datasetGeneratedAt) }}</ng-container>.
        </div>
      </ng-container>
    </div>

    <div class="map-wrap">
      <div #mapEl class="map"></div>
      <div *ngIf="mapKind === 'maplibre'" class="map-note text-xs">{{ googleRefusedNote }}</div>
      <button *ngIf="moved" pButton type="button" class="p-button-sm search-here" label="Search here" icon="pi pi-search" (click)="searchHere()"></button>
    </div>
  </div>
</div>
